/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

        function scrollToZl(){
            event.preventDefault();
	        var iframes = document.getElementsByTagName('iframe');
	        console.log(iframes.length);
            for (const iframe of iframes) 
                if(iframe.src.indexOf("zhiliao") > 10){
                    iframe.scrollIntoView();
                }
            return false;
        }
        function iframeOnload(){
        }

	    window.addEventListener('message', function(event) {
	        var data = event.data;
	        if (data.paperIframeHeight) {
	            var iframes = document.getElementsByTagName('iframe');
	            if(data.paperStat){
                    const l = document.querySelectorAll('a.citations__link');
                    if(l.length>0)for(const c of l){c.innerHTML='Citations&nbsp;<span style="color:red;">('+ data.paperStat.totalCount +')</span>';}
                    else {
                        const tb = document.querySelectorAll('.product-block-list__item--tabs .tab');
                        if(tb.length>0){
                            const div = document.createElement('div');
                            div.setAttribute("class","tab");
                            const a = document.createElement('a');
                            a.setAttribute("href","#citations-container");
                            a.innerHTML='Citations&nbsp;<span style="color:red;">('+ data.paperStat.totalCount +')</span>';
                            div.appendChild(a);
                            div2 = div.clo
                            tb[tb.length - 1].after(div);
                            const sku = document.querySelector("span.product-meta__sku");
                            sku.after(div.cloneNode(true));
                        }
                    }
                    const cnt = document.querySelector('#product-description .citations-count');
                    if(cnt)cnt.innerHTML="<h2>Available Citations</h2><div><a href='#citations-container'>x"+data.paperStat.totalCount+"</a></div>";
	            }
	            for (const iframe of iframes) 
	                if(iframe.src.indexOf("zhiliao") > 10){
	                    iframe.style.height = (data.paperIframeHeight + 20) + 'px';
	                    iframe.setAttribute("scrolling", "no");
	                    iframe.style.overflow = "hidden";
	                    iframe.style.scrollMarginTop = "200px";
	                    iframe.setAttribute("sandbox", "allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-use-activation");
	                }
	        }
	    });

(() => {
  const quoteButtonWeight = 'var(--text-font-bolder-weight)';

  const syncQuoteButtonWeight = () => {
    document.querySelectorAll('.omgrfq-btn-quotes').forEach((button) => {
      if (button.style.getPropertyValue('font-weight') !== quoteButtonWeight) {
        button.style.setProperty('font-weight', quoteButtonWeight, 'important');
      }
    });
  };

  // The quote app sets font-weight inline with !important, so CSS can't override it
  new MutationObserver(syncQuoteButtonWeight).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  syncQuoteButtonWeight();
})();

(() => {
  const quotePopupSelector = '.omgrfq-overlay';
  const waitTimeout = 8000;

  let isRequesting = false;
  let isNavigating = false;

  const findQuoteButton = () => document.querySelector('#mini-cart .omgrfq-btn-quotes') || document.querySelector('.omgrfq-button-cart .omgrfq-btn-quotes');

  const waitFor = (check) => new Promise((resolve) => {
    const initialResult = check();
    if (initialResult) {
      resolve(initialResult);
      return;
    }

    const observer = new MutationObserver(() => {
      const result = check();
      if (result) {
        finish(result);
      }
    });
    const timeoutId = setTimeout(() => finish(check()), waitTimeout);
    const finish = (result) => {
      observer.disconnect();
      clearTimeout(timeoutId);
      resolve(result);
    };
    observer.observe(document.body, { childList: true, subtree: true });
  });

  const refreshCart = () => document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));

  const lockButton = (button) => {
    isRequesting = true;
    button.setAttribute('disabled', 'disabled');
  };

  const navigate = (action) => {
    isNavigating = true;
    action();
  };

  const goToCart = () => navigate(() => {
    window.location.href = window.routes.cartUrl;
  });

  const submitForm = (form) => navigate(() => form.submit());

  const showError = (button, message) => {
    const productForm = button.closest('product-form');
    if (typeof productForm?._showAlert === 'function') {
      productForm._showAlert(message, 'error', button);
    } else {
      window.alert(message);
    }
  };

  // The quote app builds its form from the cart, so the product is added first and the popup is opened from the cart button
  const requestQuote = async (button, form) => {
    lockButton(button);
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    try {
      const staleQuoteButton = findQuoteButton();
      const formData = new FormData(form);
      const response = await fetch(`${window.routes.cartAddUrl}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        const message = error.description || error.message;
        if (message) {
          showError(button, message);
        } else {
          submitForm(form);
        }
        return;
      }

      const addedItem = await response.json().catch(() => ({}));
      // Dispatched on document so third-party listeners are notified without the theme opening the cart drawer under the popup
      document.dispatchEvent(new CustomEvent('product:added', {
        detail: { variant: addedItem, quantity: Number(formData.get('quantity')) || 1 }
      }));

      if (button.closest('.modal')) {
        document.dispatchEvent(new CustomEvent('modal:close'));
      }
      refreshCart();

      const quoteButton = await waitFor(() => {
        const candidate = findQuoteButton();
        return candidate !== staleQuoteButton && candidate;
      });

      if (!quoteButton) {
        goToCart();
        return;
      }

      quoteButton.click();
      if (!(await waitFor(() => document.querySelector(quotePopupSelector)))) {
        goToCart();
      }
    } catch (error) {
      goToCart();
    } finally {
      if (!isNavigating) {
        isRequesting = false;
        button.removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      }
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quote-only-request]');
    if (!button) {
      return;
    }
    event.preventDefault();

    const form = button.closest('form[action*="/cart/add"]');
    if (isRequesting || !form || !form.reportValidity()) {
      return;
    }

    // Without the cart drawer or the quote app there is no quote button to open, so the cart page takes over
    if (window.theme.cartType === 'page' || window.theme.pageType === 'cart' || !window.OMGRFQConfigs) {
      lockButton(button);
      submitForm(form);
      return;
    }

    requestQuote(button, form);
  });

  // A page restored with the Back button keeps the locked state from before the redirect
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted || !isNavigating) {
      return;
    }
    isNavigating = false;
    isRequesting = false;
    document.querySelectorAll('[data-quote-only-request][disabled]').forEach((button) => button.removeAttribute('disabled'));
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  });
})();
